import { render, staticRenderFns } from "./ScreeningFormList.vue?vue&type=template&id=53bd62f4&scoped=true"
import script from "./ScreeningFormList.vue?vue&type=script&lang=js"
export * from "./ScreeningFormList.vue?vue&type=script&lang=js"
import style0 from "./ScreeningFormList.vue?vue&type=style&index=0&id=53bd62f4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd62f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bd62f4')) {
      api.createRecord('53bd62f4', component.options)
    } else {
      api.reload('53bd62f4', component.options)
    }
    module.hot.accept("./ScreeningFormList.vue?vue&type=template&id=53bd62f4&scoped=true", function () {
      api.rerender('53bd62f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screening/screeningDataInfo/ScreeningFormList.vue"
export default component.exports